import { Injectable } from '@angular/core';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';
import { environment } from 'src/environments/environment';
import { Tag } from '../utils.model';

@Injectable()
export class LanguageRepositoryService {

  private _languages: Tag[];
  private _selectedLanguage: string = localStorage.getItem('selectedLanguage') || 'en';
  private languagesLoaded: boolean = false;

  private loadLanguagesInterval: any | null = null;
  private loadLanguagesTimeoutInterval: any | null = null;

  constructor(private translate: TranslateFirebaseService) {
    if(!this.languagesLoaded) this.loadLanguages();
  }

  public get languages(): Tag[] | undefined {
    let data : Tag[];
    if (this._languages) return this._languages;
    else data = JSON.parse(sessionStorage.getItem(environment.storage.upsBackofficeLanguages));
    if (data != null) return data;
    else return undefined;
  }

  public set languages(value: Tag[] | undefined) {
    if (value) {
      sessionStorage.setItem(environment.storage.upsBackofficeLanguages, JSON.stringify(value));
      this._languages = value;
    }
  }

  get selectedLanguage(): string {
    return this._selectedLanguage;
  }

  set selectedLanguage(lang: string) {
    this._selectedLanguage = lang;
  }

  loadLanguages() {
    if (!this.languagesLoaded) {
      this.loadLanguagesInterval = setInterval(() => { 
        try {
          const loadedTranslationItem = this.translate.getTranslation('enum_languages')
          if (loadedTranslationItem) {
            const loadedLanguages = JSON.parse(loadedTranslationItem); 
            if (loadedLanguages) {
              this.languages = loadedLanguages;
              this.languagesLoaded = true;

              this.clearLoadLanguageIntervals();
            }
            else {
              this.setLoadLanguagesTimeout();  
            }
          }
          else {
            this.setLoadLanguagesTimeout();
          }
        }
        catch (loadError) {
          console.warn("Error on load languages", loadError);
          
          // no point in continuing if he has given exception
          this.clearLoadLanguageIntervals();
        }
      }, 300);
    }
  }

  setLoadLanguagesTimeout() {
    this.loadLanguagesTimeoutInterval = setInterval(() => { 
      this.clearLoadLanguageIntervals();
    }, 3000);
  }

  clearLoadLanguageIntervals() {
    if (this.loadLanguagesInterval) {
      clearInterval(this.loadLanguagesInterval);
      this.loadLanguagesInterval = null;
    }
    if (this.loadLanguagesTimeoutInterval) {
      clearInterval(this.loadLanguagesTimeoutInterval);
      this.loadLanguagesTimeoutInterval = null;
    }
  }
}
